export default __webpack_public_path__ + "static/media/how.cff06f9b.png";